// angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

// libs
import { UIModule } from '@c4/ui';

// external
import { QuickstartCommonModule } from '../quickstart-common/quickstart-common.module';
import { ProgrammingCommonModule } from '../../common/common.module';

// module
import { QSNotificationsActionComponent } from './action/action.component';
import { QSNotificationsCommandComponent } from './action/command/command.component';
import { QSNotificationsParametersComponent } from './action/parameters/parameters.component';
import { QSNotificationsService } from './services/notifications.service';
import { QSPushNotificationComponent } from './push-notification/push-notification.component';
import { QSEmailNotificationComponent } from './email-notification/email-notification.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    UIModule,
    ProgrammingCommonModule,
    QuickstartCommonModule
  ],
  providers: [
    QSNotificationsService
  ],
  declarations: [
    QSNotificationsActionComponent,
    QSNotificationsCommandComponent,
    QSNotificationsParametersComponent,
    QSPushNotificationComponent,
    QSEmailNotificationComponent,
  ]
})
export class QuickstartNotificationsModule { }



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-notifications/notifications.module.ts